import $ from 'jquery';

$(($) => {
	$('.schema-faq-section').on('click', function () {
		const $this = $(this);
		if ($this.hasClass('open')) {
			$('.schema-faq-answer', $this).slideUp('fast');
		} else {
			$('.schema-faq-answer', $this).slideDown('fast');
		}
		$this.toggleClass('open');
	});
});
